import { ControlListProps, useTranslations } from "@bsm/component";
import { useGetMonths } from "../../../hooks/useGetMonths";
import { ItemsControl } from "../components/ItemsControl";
import { useGetLastFiveSchoolYears } from "./useGetLastFiveSchoolYears";
import { useClassMenuItems } from "views/list/hooks/useClassMenuItems";
import _ from "lodash";

export const useScholarityCreateForm = (id?: number): ControlListProps => {
    const [
        SAVE,
        CANCEL,
    ] = useTranslations(i18n);

    const months = useGetMonths()
    const classes = useClassMenuItems();
    const schoolYears = useGetLastFiveSchoolYears();

    return {
        data: {
            forms: [
                {
                    type: "input",
                    name: "designation",
                    label: "designation",
                    className: '',
                    placeholder: "eg: Year 1 2025-2026",
                    required: true,
                },
                {
                    type: "items",
                    name: "monthBegin",
                    label: "Month begin",
                    options: months,
                    required: true,
                },
                {
                    type: "items",
                    name: "monthEnd",
                    label: "Month end",
                    options: months,
                    required: true,
                },
                {
                    type: "items",
                    name: "schoolYear",
                    label: "School year",
                    className: '',
                    options: schoolYears,
                    required: true
                },
                {
                    type: "select",
                    name: "scholarityClass",
                    options: classes.map((item) => ({
                        label: item.label,
                        value: item.value
                    })),
                    valueObject: true,
                    valueProperty: "value",
                    className: '',
                    label: "Class",
                    required: true,
                },
                {
                    type: 'numeric',
                    name: 'schoolFeeAmount',
                    label: "School fee amount (GBP)",
                    className: ''
                },
                {
                    type: 'numeric',
                    name: 'registrationFeeAmount',
                    label: "School registration fee amount (GBP)",
                    className: ''
                }
            ],
            value: {},
            next: {
                label: SAVE,
                className: "btn btn-primary text-white",
            },
            back: {
                label: CANCEL,
            },
            fields: {
                "items": ItemsControl
            }
        },
        onBeforeSetFormData: (value) => {
            return {
                ...value,
                monthBegin: parseInt(value.monthBegin),
                monthEnd: parseInt(value.monthEnd)
            };
        },
        onBeforeSaving: (value) => {
            return {
                ...(_.omit(value, ['class'])),
                scholarityClass: value.class
            }
        },
        id: "scholarity-form",
    };
}

const i18n = [
    "std_save",
    "std_cancel",
]